import NetSuiteLogo from "@velaro/velaro-component-lib/dist/images/NetSuite Logo.png";
import FormstackLogo from "@velaro/velaro-component-lib/dist/images/Formstack Logo.svg";
import AccelaLogo from "@velaro/velaro-component-lib/dist/images/accela.jpg";
import ShopifyLogo from "@velaro/velaro-component-lib/dist/images/shopify.png";
import { IconPlus } from "@velaro/velaro-component-lib/";

export const applications = [
  {
    id: "new",
    name: "Request New App",
    category: "all",
    icon: IconPlus,
    subTitle:
      "Submit your application integration suggestion by completing our request form"
  },
  {
    id: "netsuite",
    name: "Netsuite CRM",
    category: "all",
    icon: NetSuiteLogo,
    subTitle:
      "Connect directly to manage and streamline your customer communications and data."
  },
  {
    id: "formstack",
    name: "Formstack",
    category: "all",
    icon: FormstackLogo,
    subTitle:
      "Collect, manage, and automate form submissions to enhance workflows and improve data accuracy."
  },
  {
    id: "accela-civic",
    name: "Accela Civic",
    category: "all",
    icon: AccelaLogo,
    subTitle:
      ""
  },
  {
    id: "shopify",
    name: "Shopify",
    category: "all",
    icon: ShopifyLogo,
    subTitle:
      "Integrate Shopify to sync e-commerce activities with customer profiles directly."
  },
  {
    id: "hubspot",
    name: "HubSpot CRM",
    category: "all",
    icon: IconPlus,
    subTitle:
      "Connect HubSpot to look up contacts, push transcripts, and sync chat data to your CRM."
  },
  {
    id: "dynamics",
    name: "Microsoft Dynamics 365",
    category: "all",
    icon: IconPlus,
    subTitle:
      "Connect Dynamics 365 to look up contacts, create leads and cases, and sync chat data to your CRM."
  },
  {
    id: "bigcommerce",
    name: "BigCommerce",
    category: "all",
    icon: IconPlus,
    subTitle:
      "Integrate BigCommerce to look up customers, orders, and products during live support chats."
  },
  {
    id: "mcp",
    name: "MCP Servers",
    category: "all",
    icon: IconPlus,
    subTitle:
      "Connect AI workflow nodes to external tools via the Model Context Protocol, with full conversation context awareness."
  }
];
